
import { createSlice } from '@reduxjs/toolkit';

const hotelFilterSlice = createSlice({
    name: 'hotelFilter',
    initialState: {
        filteredData: null,
        selectedRatings: [],
        selectedLocation: [],
        sortOrder: '',
        searchQuery: '',
        priceRange: [0, 100],
        defaultPriceRange: [0, 100],
    },
    reducers: {
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },

        setPriceRange: (state, action) => {
            state.priceRange = action.payload;
        },
        setSelectedRatings: (state, action) => {
            state.selectedRatings = action.payload;
        },
        setSelectedLocation: (state, action) => {
            state.selectedLocation = action.payload;
        },
        setSortOrder: (state, action) => {
            state.sortOrder = action.payload; 
        },
        setFilteredData: (state, action) => {
            state.filteredData = action.payload;
        },
        clearAllFilters: (state, action) => {
            const { allHotelList } = action.payload;
            const minPrice = allHotelList?.priceRange?.minPrice || 0;
            const maxPrice = allHotelList?.priceRange?.maxPrice || 100;

            state.selectedRatings = [];
            state.selectedLocation = [];
            state.sortOrder = '',
                state.priceRange = [minPrice, maxPrice];
            state.filteredData = { ...allHotelList };
            state.searchQuery = '';
        },
        applyFilters(state, action) {
            const { allHotelList } = action.payload;
            if (!allHotelList) return;

            let filtered = allHotelList.hotels;
            const { priceRange, selectedRatings, selectedLocation, sortOrder, searchQuery } = state;

            // Filter by ratings
            if (selectedRatings.length > 0) {
                filtered = filtered.filter(hotel =>
                    selectedRatings.includes(hotel.rt)
                );
            }

            // Filter by location
            if (selectedLocation.length > 0) {
                filtered = filtered.filter(hotel =>
                    selectedLocation.includes(hotel?.ad?.city?.name)
                );
            }

            if (sortOrder === 'asc') {
                filtered = filtered.slice().sort((a, b) => a.pops?.[0]?.tpc - b.pops?.[0]?.tpc);
            } else {
                filtered = filtered.slice().sort((a, b) => b.pops?.[0]?.tpc - a.pops?.[0]?.tpc);
            }


            if (searchQuery) {
                filtered = filtered.filter((hotel) =>
                    hotel?.name?.toLowerCase().includes(searchQuery.toLowerCase())
                );
            }

            // Filter by price range
            filtered = filtered.filter((hotel) => {
                const totalPrice = hotel?.pops?.[0]?.tpc;
                return totalPrice >= priceRange[0] && totalPrice <= priceRange[1];
            });

            state.filteredData = { ...allHotelList, hotels: filtered };
        },
    },
});

export const {
    setPriceRange,
    setSelectedRatings,
    setSearchQuery,
    setSelectedLocation,
    setSortOrder,
    setFilteredData,
    clearAllFilters,
    applyFilters,
} = hotelFilterSlice.actions;

export default hotelFilterSlice.reducer;

